import { NgModule, CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HeaderComponent } from './header/header.component';
import { FooterComponent } from './footer/footer.component';
import { CoreRoutingModule } from './core-routing.module';
import { GcHeaderModule } from '@legalzoom/lib-checkout';
import { GcPlHeaderModule } from '@legalzoom/lib-checkout';
import { environment, environmentGC } from '../../../src/environments/environment';
import { GloHeaderComponent } from './glo-header/glo-header.component';
import { ContactInfoSliderComponent } from './contact-info-slider/contact-info-slider.component';
import { FormatPhonePipe } from '../shared/pipes/format-phone';

@NgModule({
  imports: [
    CommonModule,
    CoreRoutingModule,
    GcHeaderModule.forRoot(environmentGC),
    GcPlHeaderModule.forRoot(environmentGC)
  ],
  declarations: [FormatPhonePipe, HeaderComponent, GloHeaderComponent, FooterComponent, ContactInfoSliderComponent],
  exports: [FormatPhonePipe, HeaderComponent,  GloHeaderComponent, FooterComponent, GcHeaderModule, GcPlHeaderModule, ContactInfoSliderComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA]
})
export class CoreModule { }
